mutation MarkNotificationAllRead {
    markNotificationAllRead {
        user {
            id
        }
    }
}
